module.exports = __webpack_public_path__ + "5530d3f7d55331f58608e659761443ce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximanovalight.ttf
// module id = 308
// module chunks = 0